"use strict";

exports.__esModule = true;
var _DeviceStatusOverlay = require("./DeviceStatusOverlay");
Object.keys(_DeviceStatusOverlay).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceStatusOverlay[key]) return;
  exports[key] = _DeviceStatusOverlay[key];
});
var _DeviceStatusOverlayController = require("./DeviceStatusOverlayController");
Object.keys(_DeviceStatusOverlayController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceStatusOverlayController[key]) return;
  exports[key] = _DeviceStatusOverlayController[key];
});